import { selectInitialValues } from './formDataSlice';
import { unlockFormEntityData } from '../../utils/autoLockUtils';
import { selectFormEntity } from './contextSlice';

export async function unlock(state) {
  const formEntityData = selectInitialValues(state);
  const formEntity = selectFormEntity(state);
  // eslint-disable-next-line no-underscore-dangle
  if (formEntityData._lock?.locked) {
    await unlockFormEntityData({
      formEntityDataId: formEntityData.id,
      pbcToken: formEntity.pbcToken,
      formEntityToken: formEntity.token,
    });
  }
}
